import React from "react";
import { useDrop } from "react-dnd";

const style: React.CSSProperties = {
  height: "100%"
};

export interface KanbanLaneProps {
  accept: string[];
  onDrop: (item: any) => void;
}

const BCKanbanLane: React.FC<KanbanLaneProps> = ({
  accept,
  onDrop,
  children
}) => {
  const [{ canDrop }, drop] = useDrop({
    accept,
    drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <div ref={drop} style={{ ...style }} className={canDrop ? "kanban-lane-drop" : "kanban-lane"}>
      {children}
    </div>
  );
};

export default BCKanbanLane;
